module.exports = __webpack_public_path__ + "373a62122c25d95cc88c2506ae52c556.MP3";